export type ScheduleViewMode = "weekly" | "agenda" | "daily";

/**
 * Week and day views always reopen on today. Agenda keeps its current
 * positioning because it manages its own automatic scroll target.
 */
export function getViewSwitchTargetDate(
  viewMode: ScheduleViewMode,
  now: Date = new Date(),
): Date | null {
  return viewMode === "agenda" ? null : now;
}